import { isLinkXHRData } from './predicates'
import { OpenXhrModalOptions } from '@app/types'
import { AvailableModals } from './types'

import ModalCitizen from './modal-citizen'
import { SfLog } from '@app/adapters/logger'

const makeBootstrapModalCitizen =
  (availableModals: AvailableModals) => (): void => {
    if (window.modalCitizen) {
      window.modalCitizen.cleanupXhrModals()
    }

    window.modalCitizen = new ModalCitizen(availableModals)
  }

const cleanup = (): void => {
  if (window.modalCitizen) {
    window.modalCitizen.cleanup()
  }
}

const handleXhrModalClick = (e: Event): void => {
  const target = e.target as HTMLAnchorElement
  const optionsToParse =
    typeof target?.dataset?.xhrModal === 'string'
      ? target?.dataset?.xhrModal
      : '{}'

  try {
    const modalOptions = JSON.parse(optionsToParse) as Record<string, unknown>
    const optionsArray = Object.values(modalOptions)

    if (isLinkXHRData(optionsArray)) {
      window.modalCitizen.openXhrModal(
        e,
        optionsArray[0],
        optionsArray[1],
        optionsArray[2] as OpenXhrModalOptions
      )
    }
  } catch (e) {
    SfLog.error('Error parsing xhr modal options', {
      error: e,
    })
  }
}

export default (availableModals: AvailableModals): (() => void) => {
  // Needs to be re-initialized after each turbolinks page load
  const bootstrapModalCitizen = makeBootstrapModalCitizen(availableModals)

  $(document).on('turbolinks:load', bootstrapModalCitizen)
  $(document).on('turbolinks:before-cache', cleanup)
  $(document).on('click', 'a[data-xhr-modal]', handleXhrModalClick)

  return () => {
    $(document).off('turbolinks:load', bootstrapModalCitizen)
    $(document).off('turbolinks:before-cache', cleanup)
    $(document).off('click', 'a[data-xhr-modal]')
  }
}
